import React, { useState, useEffect, useRef, FC } from 'react';

import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { uploadPosterRequested } from '../redux/reducers/project.slice';

import toast from 'react-hot-toast';

import { ReactComponent as ImageHolderSVG } from '../svg/image-holder.svg';

const Poster: FC = () => {
  const [isUploading, setIsUploading] = useState(false);
  const inputRef = useRef<null | HTMLInputElement>(null);

  const project = useAppSelector((state) => state.project.current);
  const dispatch = useAppDispatch();
  const [selectedFile, setSelectedFile] = useState<null | File>(null);

  async function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (!event.target.files?.length || !project) return;

    const file = event.target.files[0];

    setSelectedFile(file);

    const toastLoading = toast.loading('Uploading');
    setIsUploading(true);

    try {
      dispatch(uploadPosterRequested({ project, file }));
    } catch (error) {
      console.log(error);
    }
    
    setIsUploading(false);
    toast.remove(toastLoading);
    event.target.value = '';
  }

  const currentFile = inputRef.current?.files?.length ? inputRef.current?.files[0] : null;

  return (
    <section className="film-poster" onClick={() => !currentFile && !isUploading && inputRef.current?.click()}>
      <React.Fragment>
        {selectedFile ? (
          <div className="film-poster--img">
            <img src={URL.createObjectURL(selectedFile)} />
          </div>
        ) : (
          project?.fileName && (
            <div className="film-poster--img">
              <img src={`https://xyz-project-bucket.s3.us-west-2.amazonaws.com/${project?.fileName}`} />
            </div>
          )
        )}
      </React.Fragment>

      <React.Fragment>
        {!selectedFile && !project?.fileName && (
          <div>
            <div>
              <ImageHolderSVG />
            </div>
            <div>
              <span className="highlight-text">Upload</span> film poster
            </div>
          </div>
        )}
      </React.Fragment>

      <input
        style={{ display: 'none' }}
        type="file"
        onChange={handleChange}
        ref={inputRef}
        accept="image/*,.jpg,.png,.jpeg"
      />
    </section>
  );
};

export default Poster;
